import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { datadogRum } from '@datadog/browser-rum';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	handleError(error: Error) {
		if (environment.enableObservability) {
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
			datadogRum.addError(error, { error: { stack: error?.stack } });
			return;
		}
	}
}
